export const API_ERRORS = {
    INVALID_CBU: 'INVALID_CBU',
    INVALID_DOCUMENT: 'INVALID_DOCUMENT',
    INVALID_BANK_TRANSFER: 'INVALID_BANK_TRANSFER',
    INVALID_INVOICE_NUMBER: 'INVALID_INVOICE_NUMBER'
};

export const BANKS = {
    AR: [{
            id: 0,
            name: 'Banco de Galicia',
            link: 'https://wsec01.bancogalicia.com.ar/scripts/homebanking/GalHBlogin.asp'
        },
        {
            id: 1,
            name: 'Banco Comafi S.A.',
            link: 'https://hb.comafi.com.ar/homebank/HBI.do'
        },
        {
            id: 2,
            name: 'Banco Santander',
            link: 'https://www.santanderrio.com.ar/banco/online/personas'
        },
        {
            id: 3,
            name: 'Banco Itau Buen Ayre S.A.',
            link: 'http://www.itau.com.ar/Paginas/default.aspx'
        },
        {
            id: 4,
            name: 'Citibank S.A.',
            link: 'https://www.argentina.citibank.com/empresas.htm'
        },
        {
            id: 5,
            name: 'Banco Macro',
            link: 'https://www.macro.com.ar/bancainternet/'
        },
        {
            id: 6,
            name: 'Banco Credicoop',
            link: 'https://www.bancocredicoop.coop/#/personas'
        },
        {
            id: 7,
            name: 'Banco de la Provincia de Bs. As.',
            link: 'https://www.bancoprovincia.bancainternet.com.ar/eBanking/login/inicio.htm'
        },
        {
            id: 8,
            name: 'Banco Nación',
            link: 'http://www.bna.com.ar/Personas/HomeBanking'
        },
        {
            id: 9,
            name: 'BBVA Banco Francés',
            link: 'https://www.bbvafrances.com.ar/'
        },
        {
            id: 10,
            name: 'HSBC Bank Argentina S.A.',
            link: 'https://www2.security.online-banking.hsbc.com.ar/gsa/SaaS30Resource/'
        },
        {
            id: 11,
            name: 'Industrial and Commercial Bank of China S.A.',
            link: 'https://www.icbc.com.ar/personas'
        },
        {
            id: 12,
            name: 'ABN AMRO Bank'
        },
        {
            id: 13,
            name: 'Banco Ciudad',
            link: 'https://www.bancociudad.com.ar/institucional/'
        },
        {
            id: 14,
            name: 'Banco CMF S.A.',
            link: 'https://www.bancocmf.com.ar'
        },
        {
            id: 15,
            name: 'Banco de Córdoba',
            link: 'https://www.bancor.com.ar/718_APP/'
        },
        {
            id: 16,
            name: 'Banco de Corrientes S.A.',
            link: 'https://www.bancodecorrientes.com.ar/sitio/'
        },
        {
            id: 17,
            name: 'Banco de La Pampa',
            link: 'https://www.bancodelapampa.com.ar'
        },
        {
            id: 18,
            name: 'Banco de San Juan S.A.',
            link: 'https://www.bancosanjuan.com/Pages/'
        },
        {
            id: 19,
            name: 'Banco de Santa Cruz S.A.',
            link: 'https://www.bancosantacruz.com/pages/index.aspx'
        },
        {
            id: 20,
            name: 'Banco de Tucumán',
            link: 'https://www.bancotucuman.com.ar/PortalTucuman/faces/oracle/webcenter/portalapp/pages/personas.jspx?_afrLoop=55574747304456530&_afrWindowMode=0&_afrWindowId=19wds6kj55_1#%40%3F_afrWindowId%3D19wds6kj55_1%26_afrLoop%3D55574747304456530%26_afrWindowMode%3D0%26_adf.ctrl-state%3D19wds6kj55_77'
        },
        {
            id: 21,
            name: 'Banco del Chubut',
            link: 'https://www.bancochubut.com.ar'
        },
        {
            id: 22,
            name: 'Banco Finansur S.A.',
            link: 'https://www.bancofinansur.com.ar/web/institucional/contacto.php'
        },
        {
            id: 23,
            name: 'Banco Formosa S.A.',
            link: 'https://www.bancoformosa.com.ar'
        },
        {
            id: 24,
            name: 'Banco Hipotecario S.A.',
            link: 'https://www.hipotecario.com.ar'
        },
        {
            id: 25,
            name: 'Banco Supervielle S.A.',
            link: 'http://www.supervielle.com.ar'
        },
        {
            id: 26,
            name: 'Banco Patagonia S.A.',
            link: 'http://www.bancopatagonia.com/personas/personas.shtml'
        },
        {
            id: 27,
            name: 'Banco Municipal de Rosario',
            link: 'https://www.bmros.com.ar'
        },
        {
            id: 28,
            name: 'Banco Pcia. de Tierra del Fuego',
            link: 'https://www.bancotdf.com.ar'
        },
        {
            id: 29,
            name: 'Nuevo Banco del Chaco S.A.',
            link: 'http://www.nbch.com.ar'
        },
        {
            id: 30,
            name: 'Nuevo Banco Industrial de Azul',
            link: 'https://www.bind.com.ar'
        },
        {
            id: 31,
            name: 'Deutsche Bank S.A.',
            link: 'https://www.db.com/argentina/index_e.html'
        },
        {
            id: 32,
            name: 'Nuevo Banco de Santa Fe',
            link: 'http://www.bancosantafe.com.ar/Pages/'
        },
        {
            id: 33,
            name: 'Banco Santiago del Estero S.A.',
            link: 'http://www.bse.com.ar'
        },
        {
            id: 34,
            name: 'Banco Más Ventas',
            link: 'https://www.bancomasventas.com.ar/banca-personal/nuestros-servicios/'
        },
        {
            id: 35,
            name: 'Banco Provincia del Neuquén',
            link: 'https://www.bpn.com.ar'
        },
        {
            id: 36,
            name: 'Nuevo Banco de Entre Ríos S.A.',
            link: 'https://www.nuevobersa.com.ar/Pages/'
        }
    ],
    CO: [{
            id: 0,
            code: 'BBVA_CO_BANK',
            name: 'BBVA',
            link: 'https://www.bbva.com.co'
        },
        {
            id: 1,
            code: 'DAVIVIENDA_CO_BANK',
            name: 'Banco Davivienda',
            link: 'https://www.davivienda.com'
        },
        {
            id: 2,
            code: 'PICHINCHA_CO_BANK',
            name: 'Banco Pichincha',
            link: 'https://www.bancopichincha.com.co'
        },
        {
            id: 3,
            code: 'FALABELLA_CO_BANK',
            name: 'Banco Falabella',
            link: 'https://www.bancofalabella.com.co'
        },
        {
            id: 4,
            code: 'AVVILLAS_CO_BANK',
            name: 'Banco Av Villas',
            link: 'https://www.avvillas.com.co'
        },
        {
            id: 5,
            code: 'GNB_CO_BANK',
            name: 'GNB Sudameris',
            link: 'https://www.gnbsudameris.com.co'
        },
        {
            id: 6,
            code: 'CSOCIAL_CO_BANK',
            name: 'Banco Caja Social',
            link: 'https://www.bancocajasocial.com'
        },
        {
            id: 7,
            code: 'COLMENA_CO_BANK',
            name: 'Colmena',
            link: 'https://www.bancocajasocial.com'
        },
        {
            id: 8,
            code: 'COLPATRIA_CO_BANK',
            name: 'Banco Colpatria',
            link: 'https://www.colpatria.com'
        },
        {
            id: 9,
            code: 'BANCOOMEVA_CO_BANK',
            name: 'Bancoomeva',
            link: 'http://www.bancoomeva.com.co'
        },
        {
            id: 10,
            code: 'COOPCENTRAL_CO_BANK',
            name: 'Banco Cooperativo Coopcentral',
            link: 'https://www.coopcentral.com.co'
        },
        {
            id: 11,
            code: 'POPULAR_CO_BANK',
            name: 'Banco popular',
            link: 'https://www.bancopopular.com.co'
        },
        {
            id: 12,
            code: 'ITAU_CO_BANK',
            name: 'ITAU',
            link: 'https://itau.co'
        },
        {
            id: 13,
            code: 'BANCOLOMBIA_CO_BANK',
            name: 'Bancolombia',
            link: 'https://www.grupobancolombia.com'
        },
        {
            id: 14,
            code: 'PROCREDIT_CO_BANK',
            name: 'Banco Procredit',
            link: 'http://www.bancoprocredit.com.co/es/'
        },
        {
            id: 15,
            code: 'BOGOTA_CO_BANK',
            name: 'Banco de Bogota',
            link: 'https://www.ban{ id: 1, codebogota.com'
        },
        {
            id: 16,
            code: 'CITIBANK_CO_BANK',
            name: 'CitiBank',
            link: 'https://www.citibank.com.co'
        },
        {
            id: 17,
            code: 'OCCIDENTE_CO_BANK',
            name: 'Banco de Occidente',
            link: 'https://www.ban{ id: 1, codeoccidente.com.co'
        },
        {
            id: 18,
            code: 'OLDMUTUAL_CO_BANK',
            name: 'Oldmutual',
            link: 'https://www.oldmutual.com.co'
        },
        {
            id: 19,
            code: 'AGRARIO_CO_BANK',
            name: 'Banco Agrario de Colombia',
            link: 'https://www.bancoagrario.gov.co'
        },
        // Nuevos
        {
            id: 20,
            code: 'BANCOMPARTIR_CO_BANK',
            name: 'Banco Compartir',
            link: 'https://www.bancompartir.co/#!inicio'
        },
        {
            id: 21,
            code: 'FINANDINA_CO_BANK',
            name: 'Banco Finandina',
            link: 'https://www.bancofinandina.com/'
        },
        {
            id: 22,
            code: 'MULTIBANK_CO_BANK',
            name: 'Banco Multibank',
            link: 'https://www.multibank.com.pa/'
        },
        {
            id: 23,
            code: 'COLTEFINANCIERA_CO_BANK',
            name: 'Coltefinanciera',
            link: 'http://www.coltefinanciera.com.co/'
        },
        {
            id: 24,
            code: 'CONFIAR_CO_BANK',
            name: 'Confiar SA',
            link: 'https://www.confiar.coop/'
        },
        {
            id: 25,
            code: 'COOPFINANCIERA_CO_BANK',
            name: 'Cooperativa financiera',
            link: 'http://www.cfa.com.co/index.php'
        },
        {
            id: 26,
            code: 'CORPBANCA_CO_BANK',
            name: 'Banco Corpbanca',
            link: 'https://www.bancocorpbanca.com.co/portal/secciones/BSCH/HOME/PERSONAS/seccion_HTML.jsp'
        },
        {
            id: 27,
            code: 'COTRAFA_CO_BANK',
            name: 'Cotrafa',
            link: 'http://www.cotrafa.com.co/'
        },
        {
            id: 28,
            code: 'JURISCOOP_CO_BANK',
            name: 'Financiera Juriscoop',
            link: 'https://www.financierajuriscoop.com.co/'
        },
        {
            id: 29,
            code: 'NEQUI_CO_BANK',
            name: 'Nequi',
            link: 'https://www.nequi.com.co/'
        }
    ],
    CL: [{
            id: 1,
            name: 'Banco Itaú',
            link: 'https://banco.itau.cl/wps/portal/BICPublico/home/!ut/p/b1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOJN_f2MLf3DLAP9_S0sDTy9nH3cAwP9jF2DTYAKIoEKDHAARwNC-r30o9Jz8pOAVoXrR-FTHOhjClWAxzI_j_zcVP2C3IjK4IB0RQCU_xEs/dl4/d5/L2dBISEvZ0FBIS9nQSEh'
        },
        {
            id: 2,
            name: 'Banco Santander',
            link: 'https://www.santander.cl'
        },
        {
            id: 3,
            name: 'Scotiabank',
            link: 'https://www.scotiabankchile.cl/'
        },
        {
            id: 4,
            name: 'Banco Security',
            link: 'https://personas.bancosecurity.cl/'
        },
        {
            id: 5,
            name: 'Banco Ripley',
            link: 'https://www.bancoripley.cl/'
        },
        {
            id: 6,
            name: 'Banco Estado',
            link: 'https://www.bancoestado.cl/imagenes/_personas/home/default.asp'
        },
        {
            id: 7,
            name: 'Banco Falabella',
            link: 'https://www.bancofalabella.cl/BancoFalabellaChile/index.html'
        },
        {
            id: 8,
            name: 'Banco Bice',
            link: 'http://www.bice.cl/'
        },
        {
            id: 9,
            name: 'Banco HSBC',
            link: 'http://www.hsbc.cl/'
        },
        {
            id: 10,
            name: 'Banco de Chile',
            link: 'https://login.portal.bancochile.cl/'
        },
        {
            id: 11,
            name: 'Banco Internacional',
            link: 'https://www.bancointernacional.cl/index.aspx'
        },
        {
            id: 12,
            name: 'Banco Consorcio',
            link: 'https://www.bancoconsorcio.cl'
        },
        {
            id: 13,
            name: 'Coopeuch',
            link: 'https://www.coopeuch.cl/web/guest/'
        },
        {
            id: 14,
            name: 'Banco BCI',
            link: 'https://www.bci.cl/personas'
        },
        {
            id: 15,
            name: 'Banco BBVA',
            link: 'https://www.bbva.cl/'
        },
        {
            id: 16,
            name: 'Banco Banefe',
            link: 'http://www.banefe.cl/'
        },
        {
            id: 17,
            name: 'Corpbanca',
            link: 'https://www.corpbanca.cl/portal/?id_category=10'
        }
    ],
    MA: [{
            id: 1,
            name: 'Attijari wafa bank',
            link: 'https://attijarinet.attijariwafa.com/entreprise/'
        },
        {
            id: 2,
            name: 'Bmce',
            link: 'https://www.bmcedirect.ma'
        },
        {
            id: 3,
            name: 'BMCI',
            link: 'https://www.bmcinet.net'
        },
        {
            id: 4,
            name: 'Banque populaire',
            link: 'http://www.gbp.ma/'
        },
        {
            id: 5,
            name: 'Société générale',
            link: 'http://sgmaroc-online.com/'
        },
        {
            id: 6,
            name: 'CIH',
            link: 'https://entreprises.cihonline.ma'
        },
        {
            id: 7,
            name: 'Crédit du Maroc',
            link: 'https://ebanking.cdm.co.ma'
        },
        {
            id: 8,
            name: 'CFG bank',
            link: 'https://clients.cfgbank.com'
        },
        {
            id: 9,
            name: 'Banco HSBC',
            link: 'http://www.hsbc.cl/'
        },
        {
            id: 10,
            name: 'Al barid bank',
            link: 'https://www.albaridbank.ma/wps/portal/AlBarid/Banque-Enligne'
        }
    ]
};

export const ACCOUNT_TYPES = {
    CO: [{
            key: 'CC',
            value: 'Cuenta corriente'
        },
        {
            key: 'CA',
            value: 'Cuenta de ahorro'
        }
    ]
}

export const DLOCALBANKS = {
    AR: [
        /*{
            id: 0,
            type: 'Cuenta corriente',
            name: 'Banco de Galicia',
            code: 'GL',
            beneficiary: 'DLP CAPITAL PARTNERS SA',
            account: '21948-4 011-6',
            document: '30711998612',
            document2: '00700115-20000021948468'
        },*/
        /*{
            id: 1,
            type: 'Cuenta corriente',
            name: 'Banco Comafi S.A.',
            beneficiary: 'DLP CAPITAL PARTNERS SA',
            code: 'CF',
            account: '0000-20698/9',
            document: '30711998612',
            document2: '29900000 00002069890008'
        },*/
        {
            id: 2,
            type: 'Cuenta corriente',
            name: 'Banco Macro',
            beneficiary: 'D LOCAL ARGENTINA SA',
            code: 'MA',
            account: '330209419576272',
            document: '30715778722',
            document2: '2850302630094195762721',
            alias: 'CAMARA.ALFIL.PLAYA'
        }
    ],
    CO: [
        /*{
            id: 1,
            type: 'Cuenta corriente',
            name: 'Davivienda',
            beneficiary: 'TIKREL COLOMBIA SAS',
            code: 'DA',
            account: '216069992586',
            document: '900682258-3'
        },*/
        {
            id: 13,
            type: 'Cuenta de ahorro',
            name: 'Bancolombia',
            beneficiary: 'DLOCAL COLOMBIA SAS',
            code: 'BN',
            account: '57159095471',
            document: '900682258-3'
        }
    ],
    CL: [{
        id: 1,
        type: 'Cuenta Corriente',
        name: 'Banco Itaú',
        beneficiary: 'Pagos y Servicios Astropay Ltda',
        code: 'I',
        account: '0212890774',
        document: '76248923-6'
    }],
    MA: [
        /*{
            id: 1,
            type: 'Cuenta Corriente',
            name: 'Banque Populaire',
            beneficiary: 'Centre D\'Affaire Espace Porte D\'Anfa',
            account_name: 'Vantage Payment Systems',
            code: 'PP',
            account: '190 780 21211 3262848 0080 47'
        }*/
        /*{
            id: 1,
            type: 'Cuenta Corriente',
            name: 'AttijariWafa Bank',
            beneficiary: 'DAR ALMOUKAWIL TANGER PASTEUR',
            account_name: 'DEPANSUM MARRUECOS',
            code: 'PP',
            account: '007 640 00143 3300000 0409 62'
        },*/
        {
            id: 2,
            type: 'Cuenta Corriente',
            name: 'BMCE Bank',
            beneficiary: 'TANGER VILLE',
            account_name: 'Dlocal Morocco',
            code: 'MM',
            account: '011 780 00002 9210000 1596 61'
        }
    ]
};

export const DOCUMENT_TYPES = {
    CO: [{
            key: 'CC',
            value: 'Cédula de Ciudadanía'
        },
        {
            key: 'CE',
            value: 'Cédula de Extranjería'
        },
        {
            key: 'NIT',
            value: 'NIT'
        },
        {
            key: 'TI',
            value: 'Tarjeta de Identidad'
        },
        {
            key: 'PP',
            value: 'Pasaporte'
        },
        {
            key: 'SSE',
            value: 'Trj. Seguro Social Extranjero'
        },
        {
            key: 'SESNITC',
            value: 'Sociedad Extranjera sin NIT en Colombia'
        },
        {
            key: 'FC',
            value: 'Fideicomiso'
        },
    ]
}
export const cuit_cuil = 'CUIT/CUIL';
export const COUNTRIES = {
    AR: 'AR',
    CO: 'CO',
    CL: 'CL',
    MA: 'MA'
};

export const CURRENCY = {
    AR: 'ARS',
    CO: 'COP'
};

export const PAYMENT_CODES = {
    PSE: 'PC',
    KHIPU: 'KH'
};

export const PAYMENT_STATUS = {
    PENDING: 7,
    REJECTED: 8,
    PAID: 9,
    NOT_DEFINED: 10,
    RELEASED: 11
};

export const MANUAL_LINKS = {
    AR: "https://static.dlocal.com/booking/Manual+Booking+Checkout+(Argentina).pdf",
    CO: "https://static.dlocal.com/booking/Manual+Booking+Checkout+(Colombia).pdf",
    CL: "https://static.dlocal.com/booking/Manual+Booking+Checkout+(Chile).pdf",
    MA: "https://static.dlocal.com/booking/Manual+Booking+Checkout+(Morocco).pdf"
}

export const CURRENCY_SYMBOLS = {
    AR: '$',
    CO: '$',
    CL: '$'
};

export const CHARS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
];


export const CARD_FIELD_NAMES = {
    NAME: "name",
    CUSTOMER_NAME: "customerName",
    CUSTOMER_ID: "customerId",
    CUSTOMER_DOCUMENT: "customerDocument",
    EMAIL: "email",
    INVOICE_ITEM: "invoiceItem",
    INVOICE_AMOUNT: "invoiceAmount"
}

export const MIN_AMOUNT_CARD = {
    CO: 100,
    CL: 50
}
export const MAX_AMOUNT_CARD = {
    CO: 2000000,
    CL: 2000000
}

export const MAX_AMOUNT_CARD_DEFAULT = 200000;

export const PAYMENT_CARD_STATUS = {
    REJECTED: 'REJECTED',
    PAID: 'PAID',
    PENDING: 'PENDING'
};

export const USER_FACING_ERROR_MESSAGES = {
    INVALID_DOCUMENT: {
        AR: 'El pago no pudo ser creado porque el CUIL/CUIT ingresado es inválido. Por favor, ingrese un CUIL/CUIT válido e intente de nuevo.',
        CL: 'El pago no pudo ser creado porque el RUT ingresado es inválido. Por favor, ingrese un RUT válido e intente de nuevo.',
        CO: 'El pago no pudo ser creado porque el número de documento ingresado es inválido. Por favor, ingrese un documento válido e intente de nuevo.',
        MA: 'Le paiement n\'a pas pu être créé car le numéro de document est invalide. Veuillez saisir un numéro de document valide et réessayer.'
    }
};